import Vue from 'vue';
import Vuex from 'vuex';

import user from './modules/user';
import floatModal from './modules/floatModal';
import roi from './modules/roi';
import sys_config from './modules/sys_config';

Vue.use(Vuex);

const store = new Vuex.Store({
  modules: {
    user,
    roi,
    floatModal,
    sys_config
  }
});

// 初始化时获取 sys_config 配置
store.dispatch('sys_config/init');

export default store;
